module.exports = __webpack_public_path__ + "cd767d6271c7fb81bbae56af82565e9e.svg";